import { Box, Stack, Typography } from "@mui/material";
import moment from "moment-timezone";
import MUIDataTable from "mui-datatables";

export const ProductLogsTable = ({
	logs,
	page,
	rowsCount,
	count,
	handlePage,
	handleRowsCount,
	handleSearchChange,
}) => {
	const columns = [
		{
			name: "id",
			label: "Log ID",
			options: {
				filter: false,
				sort: true,
				setCellProps: () => ({ style: { textAlign: "center" } }),
			},
		},
		{
			name: "timestamp",
			label: "Timestamp",
			options: {
				setCellProps: () => ({ style: { textAlign: "center" } }),
				filter: false,
				sort: true,
				customBodyRender: (value) =>
					value ? new Date(value).toLocaleString() : "-",
			},
		},
		{
			name: "product",
			label: "Product ID",
			options: {
				setCellProps: () => ({ style: { textAlign: "center" } }),
				filter: false,
				sort: true,
				customBodyRender: (product) => {
					return product?.id || "-";
				},
			},
		},
		{
			name: "product",
			label: "Product Name",
			options: {
				filter: false,
				setCellProps: () => ({ style: { textAlign: "center" } }),
				sort: true,
				customBodyRender: (product) => {
					return product?.name || "-";
				},
			},
		},

		{
			name: "product",
			label: "SKU",
			options: {
				filter: false,
				setCellProps: () => ({
					style: { textAlign: "center", cursor: "pointer" },
				}),
				sort: true,
				searchable: true,
				customBodyRender: (product) => {
					if (!product?.sku) {return "-";}
					return (
						<a
							href={product?.url} // <-- make sure each product has a `url` field
							target="_blank"
							rel="noopener noreferrer"
							style={{ textDecoration: "none", color: "blue" }}
						>
							{product?.sku}
						</a>
					);
				},
			},
		},

		{
			name: "changes",
			label: "Changes",
			options: {
				setHeaderProps: () => ({
					style: { width: "700px", maxWidth: "700px" },
				}),
				setCellProps: () => ({
					style: { width: "700px", maxWidth: "700px" },
				}),
				filter: false,
				sort: false,
				customBodyRender: (changes) => {
					if (!Array.isArray(changes) || !changes.length)
						{return "No Changes";}

					return (
						<Stack spacing={1}>
							{changes.map((change, i) => {
								const fields = change?.fields || {};

								return (
									<Box
										key={i}
										sx={{
											border: "1px solid #ccc",
											borderRadius: 1,
											p: 1,
										}}
									>
										<Typography variant="body2">
											<strong>Action:</strong>{" "}
											{change?.action || "N/A"}
										</Typography>
										{/* <Typography variant="body2">
                      <strong>Scraper ID:</strong> {change?.scraper_id || "-"}
                    </Typography> */}
										<Typography variant="body2">
											<strong>Timestamp:</strong>{" "}
											{change?.timestamp
												? moment(change.timestamp)
														.tz("Asia/Kolkata")
														.format(
															"DD-MM-YYYY HH:mm:ss"
														)
												: "-"}
										</Typography>

										{Object.entries(fields).map(
											([key, val], idx) => {
												// Handle fields with old/new values
												if (
													val &&
													typeof val === "object" &&
													"old" in val &&
													"new" in val
												) {
													// Special case: size_detail array
													if (
														key === "size_detail" &&
														Array.isArray(
															val.old
														) &&
														Array.isArray(val.new)
													) {
														const changedSizes =
															val.new
																.map(
																	(
																		newItem,
																		index
																	) => {
																		const oldItem =
																			val
																				.old[
																				index
																			] ||
																			{};
																		const differences =
																			{};
																		// Compare each property in size_detail object
																		Object.keys(
																			newItem
																		).forEach(
																			(
																				prop
																			) => {
																				if (
																					JSON.stringify(
																						newItem[
																							prop
																						]
																					) !==
																					JSON.stringify(
																						oldItem[
																							prop
																						]
																					)
																				) {
																					differences[
																						prop
																					] =
																						{
																							old: oldItem[
																								prop
																							],
																							new: newItem[
																								prop
																							],
																						};
																				}
																			}
																		);
																		if (
																			Object.keys(
																				differences
																			)
																				.length
																		)
																			{return {
																				size: newItem.size,
																				differences,
																			};}
																		return null;
																	}
																)
																.filter(
																	Boolean
																);

														if (
															changedSizes.length ===
															0
														)
															{return null;}

														return (
															<Box
																key={idx}
																sx={{ mt: 0.5 }}
															>
																<Typography variant="body2">
																	<strong>
																		{key ===
																		"size_detail"
																			? "Change In Size"
																			: ""}
																		:
																	</strong>
																</Typography>
																{changedSizes.map(
																	(
																		s,
																		sIdx
																	) => (
																		<Box
																			key={
																				sIdx
																			}
																			sx={{
																				ml: 2,
																				mb: 0.5,
																			}}
																		>
																			<Typography variant="body2">
																				<strong>
																					{
																						s.size
																					}
																				</strong>{" "}
																				(size):
																			</Typography>
																			{Object.entries(
																				s.differences
																			).map(
																				(
																					[
																						prop,
																						diff,
																					],
																					pIdx
																				) => (
																					<Typography
																						key={
																							pIdx
																						}
																						variant="body2"
																						sx={{
																							ml: 2,
																						}}
																					>
																						{
																							prop
																						}

																						:{" "}
																						<span
																							style={{
																								color: "red",
																							}}
																						>
																							{JSON.stringify(
																								diff.old
																							)}
																						</span>{" "}
																						→{" "}
																						<span
																							style={{
																								color: "green",
																							}}
																						>
																							{JSON.stringify(
																								diff.new
																							)}
																						</span>
																					</Typography>
																				)
																			)}
																		</Box>
																	)
																)}
															</Box>
														);
													}

													// General old/new field
													return (
														<Box
															key={idx}
															sx={{ mt: 0.5 }}
														>
															<Typography variant="body2">
																<strong>
																	{key}:
																</strong>{" "}
																<span
																	style={{
																		color: "red",
																	}}
																>
																	{JSON.stringify(
																		val.old
																	)}
																</span>{" "}
																→{" "}
																<span
																	style={{
																		color: "green",
																	}}
																>
																	{JSON.stringify(
																		val.new
																	)}
																</span>
															</Typography>
														</Box>
													);
												}

												// Primitive or object values
												if (
													val &&
													typeof val === "object"
												) {
													return (
														<Box
															key={idx}
															sx={{ mt: 0.5 }}
														>
															<Typography variant="body2">
																<strong>
																	{key}:
																</strong>{" "}
																{JSON.stringify(
																	val
																)}
															</Typography>
														</Box>
													);
												}

												return (
													<Box
														key={idx}
														sx={{ mt: 0.5 }}
													>
														<Typography variant="body2">
															<strong>
																{key ===
																"original_product_id"
																	? "SKU"
																	: key}
																:
															</strong>{" "}
															{val || "-"}
														</Typography>
													</Box>
												);
											}
										)}
									</Box>
								);
							})}
						</Stack>
					);
				},
			},
		},
	];

	console.log("LOGS", columns);

	return (
		<MUIDataTable
			title="Product Logs"
			data={logs || []} // always provide an array
			columns={columns}
			options={{
				jumpToPage: true,
				selectableRows: "none",
				download: false,
				filter: false,
				serverSide: true,
				print: false,
				count: count,
				page: page,
				rowsPerPage: rowsCount,
				rowsPerPageOptions: [10, 25, 100],
				onChangePage: handlePage, // use prop
				onChangeRowsPerPage: handleRowsCount, // use prop
				onSearchChange: handleSearchChange, // use prop
			}}
		/>
	);
};
